import React from 'react';
import { adminUser_listAdmins_data, setAdminIpAddressVariables } from '@api/graphql/types';
import { AllFormErrors, EmptyFormErrors, getAllFormErrors, getError } from '@root/utils/ErrorHelper';
import InputText from '@components/Form/InputText';
import Notification from '@components/Notification';
import { injectIntl, InjectedIntlProps } from 'react-intl';
import { compose } from 'react-apollo';
import * as Mutations from '@api/graphql/mutations';
import GraphQLClient from '@api/graphql/GraphQLClient';
import ButtonSave from '@components/Form/ButtonSave';

interface Props {
    user: adminUser_listAdmins_data;
}

interface State {
    formData: setAdminIpAddressVariables;
    allFormErrors: AllFormErrors;
}

type PropType = Props & InjectedIntlProps;

class IpForm extends React.Component<PropType, State> {
    public constructor(props: PropType) {
        super(props);
        this.state = {
            formData: {
                id: props.user.id,
                ip_address: props.user.ip_address,
            },
            allFormErrors: EmptyFormErrors,
        };
    }

    private onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        GraphQLClient.mutate({
            mutation: Mutations.setAdminIpAddress,
            variables: this.state.formData,
        }).then(() => {
            return Notification.success(this.props.intl.formatMessage({ id: 'notification.succeed' }));
        }).catch((e: any) => {
            const allFormErrors = getAllFormErrors(e);
            this.setState({allFormErrors});

            Notification.error(this.props.intl.formatMessage({ id: 'notification.failed' }));
        });
    }

    public render() {
        const error = getError("ip_address", this.state.allFormErrors);
        return (
            <form className="form-horizontal" onSubmit={this.onSubmit}>
                <div className={`form-group row ${error ? 'has-error' : ''}`}>
                    <label className="col-sm-2 col-form-label">{this.props.intl.formatMessage({ id: 'module.adminUser.ip_address.title' })}</label>
                    <div className="col-sm-9">
                        <InputText
                            name="ip_address"
                            value={this.state.formData.ip_address || ''}
                            onChangeHandler={
                                (value: string) => {
                                    this.setState({formData: {id: this.state.formData.id, ip_address: value}});
                                }
                            }
                        />
                        {error && <span className='text-danger'>{error}</span>}
                    </div>
                    <div className="col-sm-1">
                        <ButtonSave type="submit" />
                    </div>
                </div>
            </form>
        );
    }
}

export default compose(
    injectIntl,
)(IpForm);



// WEBPACK FOOTER //
// ./src/modules/AdminUser/components/IpForm.tsx